import { hideHeaderOverlay, showHeaderOverlay } from 'Functions/overlay'
import { checkResolution, checkTouchDevice } from 'Functions/helpers'
import 'Lib/jquery/jquery.menu-aim.js'

for (const navigation of document.querySelectorAll('.js-aim-navigation')) {
    const isMainNavigation = navigation.classList.contains('is-main')
    const isSubNavigation = navigation.classList.contains('is-sub')

    const onNavTabClose = () => {
        if (!isMainNavigation) return

        requestAnimationFrame(() => {
            if (!navigation.activeTabs || !navigation.activeTabs.length) {
                hideHeaderOverlay('nav')
            }
        })
    }

    navigation.addEventListener('rTab.after.openTab', (event) => {
        if (!isMainNavigation) return

        if (!checkResolution('cxs;xs')) {
            showHeaderOverlay('nav')
        }
    })

    navigation.addEventListener('rTab.handleTrigger', (event) => {
        if (isSubNavigation || !checkResolution('cxs;xs') && event.detail.activeTabs.length) {
            event.preventDefault()
        }
    })

    // ked to je touch click, tak nech to nepresmeruje
    for (const item of document.querySelectorAll(navigation.dataset.aimRowSelector)) {
        item.addEventListener('click', (event) => {
            if (isSubNavigation && checkResolution('cxs;xs')) {
                return true
            }

            if (window.isTouchClick) {
                event.preventDefault()
            }
        })
    }

    navigation.addEventListener('rTab.after.closeAllTabs', () => {
        onNavTabClose()
    })

    navigation.addEventListener('rTab.after.closeTab', (event) => {
        onNavTabClose()
    })

    navigation.addEventListener('mouseleave', (event) => {
        if (!navigation.activeTabs || !navigation.activeTabs.length || checkResolution('cxs;xs')) {
            return
        }

        if (isMainNavigation) {
            navigation.closeAllTabs()
        }
    })

    $(navigation.dataset.aimSelector).menuAim({
        enter(row) {
            if (navigation.activeTabs && navigation.activeTabs.length) {
                return
            }

            this.activate(row)
        },
        exit() {
        },
        activate(row) {
            if (checkResolution('cxs;xs')) {
                return
            }

            if (window.overlayActiveElement && window.overlayActiveElement !== 'nav') {
                return
            }

            navigation.openTab(row.dataset.tabId)
        },
        deactivate(row) {
            if (!navigation.activeTabs.length || checkResolution('cxs;xs')) {
                return
            }

            navigation.closeTab(row.dataset.tabId)
        },
        rowSelector: navigation.dataset.aimRowSelector,
        submenuDirection: navigation.dataset.aimSubmenuDirection
    })
}

if (!checkTouchDevice()) {
    for (const navClose of document.querySelectorAll('.js-nav-tab-close')) {
        navClose.classList.add('hidden')
    }
}